import { createSelector } from 'reselect';

export const getPlayers = (state) => state.players;

export const getAllPlayers = createSelector(
    [getPlayers],
    (players) => {
        let allPlayers = players.ids.map((id) => {
            return players.byId[id];
        });
        return allPlayers;
    }
)


// WEBPACK FOOTER //
// ./src/selectors/player.selector.js